module.exports = __webpack_public_path__ + "img/1483510398.d3a1fd85.jpg";